@if (isLoadingRolloutPlanDetails()) {
<mat-progress-bar mode="indeterminate" value="50" color="primary"></mat-progress-bar>
}
<div class="py-200-rem px-250-rem bg-[#f7f9ff]" data-testid="rollout-plans">
  <div class="flex justify-between items-center space-y-050-rem">
    <h1 class="text-[1.5rem] text-[#292F32] w-full font-semibold">
      Rollout plan detail view (state: {{ rolloutPlanDetails().status }})
    </h1>
    @if (!isLoadingRolloutPlanDetails() && rolloutPlanDetails().status !== 'Stopped';) {
    <div class="flex gap-100-em items-center">
      @if (isDraft()) {
      <button (click)="openDeleteConfirmationDialog()" matButton="outlined">Delete</button>
      }

      @if(canStopRollout()){
        <button matButton="outlined" (click)="openStopConfirmationDialog()">Stop</button>
      }

      <button matButton="outlined" (click)="editRolloutPlan()">Edit</button>
      @if (isDraft()) {
      <button
        class="whitespace-nowrap"
        (click)="markRolloutReadyForReview()"
        mat-flat-button
        color="primary">
        Ready for review
      </button>
      } @if(isReadyForReview()) {
      <button matButton="outlined" (click)="openRejectConfirmationDialog()">Reject</button>
      @if (isSandbox || isReviewRequestedByCurrentUser() === false) {
      <button class="whitespace-nowrap" mat-flat-button color="primary" (click)="openApproveConfirmationDialog()" >Approve</button>
      } }

      @if(isActiveOrInactive()){
      <button
        (click)="openChangeStatusConfirmationDialog(rolloutPlanDetails().status === 'Active'? 'Inactive': 'Active')"
        class="whitespace-nowrap"
        mat-flat-button
        color="primary">
        {{ nextStatus()}}
      </button>
      }
    </div>
    }
  </div>

    <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-4 flex flex-col">
    <div>
      <h3 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default">
        Plan details
      </h3>
      <div class="flex items-center gap-x-050-rem py-100-em">
        <i
          class="icon_marina_ui_InfoOutlined text-container-fg-muted text-headline-sm"
          aria-hidden="true"></i>
        <p class="text-container-fg-muted text-body-lg-weight-regular w-2xl">
          Information on compatible device software versions is inherited from the selected firmware
          package (read-only).
        </p>
      </div>
    </div>
    <p class="text-label-lg-weight-medium text-container-fg-default space-y-3">
      Firmware package to roll out
    </p>
    <div>
      <h3 class="text-label-sm-weight-regular text-container-fg-muted">
        Firmware package bundle version
      </h3>
      <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
        {{ rolloutPlanDetails().packageVersion }}
      </p>
    </div>

    <div>
      <h4 class="text-label-lg-weight-medium text-container-fg-default py-100-em">
        Compatible device software versions
      </h4>
      <div class="grid grid-cols-2 gap-y-8">
        @for(version of formatCompatibleVersions(); track $index){
        <div class="flex items-center gap-100-em">
          <div class="text-body-md-weight-regular text-container-fg-muted">CP</div>
          <div>
            <p class="text-label-sm-weight-regular text-container-fg-muted">
              Compatible device software versions
            </p>

            <p class="text-body-lg-weight-regular text-container-fg-default">{{version}}</p>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

    <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-2 flex flex-col">
    @if(rolloutPlanDetails().strategy.strategyType === "Percentage"){
    <h2 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default pb-075-rem">
      Target product groups & rollout percentages
    </h2>
    @for (productGroup of getPercentageGroups(); track productGroup.productGroupId) {
    <div class="flex justify-between w-lg space-y-200-rem">
      <div>
        <p class="text-label-sm-weight-regular text-container-fg-muted">Target product</p>
        <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
          {{ productGroup.productGroupName }}
        </p>
      </div>
      <div>
        <p class="text-label-sm-weight-regular text-container-fg-muted">Rollout percentage [%]</p>
        <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
          {{ productGroup.percentage }}
        </p>
      </div>
    </div>
    }
  } @else {
        <h2 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default pb-075-rem">
      Devices to roll out to
    </h2>
    <table mat-table [dataSource]="getWhitelistGroups()" class="full-width-table" aria-label="Elements">
      <ng-container matColumnDef="targetProductGroups">
        <th mat-header-cell *matHeaderCellDef>TARGET PRODUCT GROUPS</th>
        <td mat-cell *matCellDef="let element">{{element.productGroupName}}</td>
      </ng-container>

      <ng-container matColumnDef="btFriendlyNames">
        <th mat-header-cell *matHeaderCellDef>BT-FRIENDLY NAME(S) OF DEVICE(S)</th>
        <td mat-cell *matCellDef="let element">
          @if (element.btFriendlyNames.length > 0) { @for (name of element.btFriendlyNames; track
          name) {
          <div>{{ name }}</div>
          } } @else {
          <span>-</span>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    }
  </div>

    <shared-domain-app-distribution
    [formattedAccess]="formattedAccess()"
    [distributionDetails]="rolloutPlanDetails().packageDistribution.supportedCompanionApps">
  </shared-domain-app-distribution>

  <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-6 flex flex-col">
    <h1 class="text-headline-sm-weight-medium text-container-fg-default text-[1.125rem]">
      Counters per target product group
    </h1>

    <remote-update-domain-app-page-wrapper
      [data]="rolloutPlanStatistics().productGroups"
      [hasError]="!!rolloutPlanStatisticHasError()"
      [emptyTitle]="emptyRolloutStatisticsTitle"
      [emptyDescription]="emptyRolloutStatisticsDescription"
      [isLoading]="isLoadingRolloutPlanStatistics()"
      [height]="height"
      [bgColor]="bgColor"
      [paddingX]="paddingX">
      <div content>
        <remote-update-feature-remote-update-dashboard-counter-per-target-product-group
          [rolloutPlanStatics]="rolloutPlanStatistics()">
        </remote-update-feature-remote-update-dashboard-counter-per-target-product-group>
      </div>
    </remote-update-domain-app-page-wrapper>
  </div>

  <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-6 flex flex-col">
    <h1 class="text-headline-sm-weight-medium text-container-fg-default text-[1.125rem]">
      Change history
    </h1>
    <remote-update-domain-app-page-wrapper
      [data]="rolloutPlanChangeHistoryData()"
      [hasError]="!!rolloutPlanHistoryHasError()"
      [emptyTitle]="emptyChangeHistoryTitle"
      [emptyDescription]="emptyChangeHistoryDescription"
      [isLoading]="isLoadingRolloutPlanChangeHistory()"
      [height]="height"
      [bgColor]="bgColor"
      [paddingX]="paddingX">
      <div content>
        <remote-update-feature-remote-update-dashboard-rollout-plan-change-history
          [data]="rolloutPlanChangeHistoryData()">
        </remote-update-feature-remote-update-dashboard-rollout-plan-change-history>
      </div>
    </remote-update-domain-app-page-wrapper>
  </div>

</div>
